import { Route, Routes, Navigate, Router } from "react-router-dom";

import Choice from "../screens/choice/choice";
import LoginBuy from "../screens/login/login-buy/login-buy";
import LoginSeller from "../screens/login/login-seller/login-seller";
import RegisterBuy from "../screens/register/register-buy/register-buy";
import LoginEngineer from "../screens/login/login-engineer/login-engineer";
import RegisterEngineer from "../screens/register/register-engineer/register-engineer";
import RegisterSeller from "../screens/register/register-seller/register-seller";
import HomeBuy from "../screens/home/home-buy/home-buy";
import HomeSeller from "../screens/home/home-seller/home-seller";
import DetailsPropertyBuy from "../screens/details-property/buy/details-property";
import DetailsPropertySeller from "../screens/details-property/seller/details-property";
import Cart from "../screens/cart/cart";
import ProfileSeller from "../screens/profile/profile-seller/profile-seller";
import News from "../screens/news/news";
import Contact from "../screens/contatos/contatos";
import Pronouncement from "../screens/pronouncement/pronouncement";
import Favorites from "../screens/favorites/favorites";
import Settings from "../screens/settings/settings";
import Search from "../screens/search/search";
import RegisterProperty from "../screens/register-property/register-property";
import PrivateRoute from "./PrivateRoute";
import CreditCardPage from "../screens/credit-card/credit-card";
import ForgetPassword from "../screens/forget-password/forget-password";
import AllProducts from "../screens/allProducts/all-products";
import UpdateProperty from "../screens/update-property/update-property";
import Order from "../screens/order/order";
import CreditCardPayment from "../screens/order/components/screens/credit-card/credit-card";
import Pix from "../screens/order/components/screens/pix/pix";
import Ticket from "../screens/order/components/screens/ticket/ticket";
import MySpaceBankRegister from "../screens/my-space/buy/my-space-bank-card";
import Satelite from "../screens/satelite/satelite";
import HomeRouter from "../screens/router/HomeRouter";
import PaySuccess from "../screens/pay-success/PaySuccess";
import PayError from "../screens/pay-success/PayError";
import RecoverPassword from "../screens/recover-password/recoverPassword";
import Catalog from "../screens/catalog/catalog";
import MapBiomas from "../screens/map-biomas/map-biomas";
import Contract from "../screens/contracts/seller/contract";
import EngineerReportRequests from "../screens/my-space/engineer/my-space-engineer-notifications";
import PropertyReport from "../screens/update-property/property-report";
import LayoutWithNavbar from "@/components/layout/layout-with-navbar";
import StripePage from "@/screens/MobilePayment";
import MySpace from "@/screens/my-space/MySpace";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/mobile-payment" element={<StripePage />} />

      <Route
        path="/choice"
        element={
          <LayoutWithNavbar>
            <Choice />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/loginBuy"
        element={
          <LayoutWithNavbar>
            <LoginBuy />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/loginSeller"
        element={
          <LayoutWithNavbar>
            <LoginSeller />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/loginEngineer"
        element={
          <LayoutWithNavbar>
            <LoginEngineer />
          </LayoutWithNavbar>
        }
      />

      <Route
        path="/"
        element={
          <LayoutWithNavbar>
            <HomeBuy />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/registerBuy"
        element={
          <LayoutWithNavbar>
            <RegisterBuy />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/registerSeller"
        element={
          <LayoutWithNavbar>
            <RegisterSeller />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/registerEngineer"
        element={
          <LayoutWithNavbar>
            <RegisterEngineer />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/forgetPassword"
        element={
          <LayoutWithNavbar>
            <ForgetPassword />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/news"
        element={
          <LayoutWithNavbar>
            <News />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/catalog"
        element={
          <LayoutWithNavbar>
            <Catalog />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/contact"
        element={
          <LayoutWithNavbar>
            <Contact />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/pronouncement"
        element={
          <LayoutWithNavbar>
            <Pronouncement />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/favorites"
        element={
          <LayoutWithNavbar>
            <Favorites />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/search"
        element={
          <LayoutWithNavbar>
            <Search />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/recoverPassword"
        element={
          <LayoutWithNavbar>
            <RecoverPassword />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/DetailsPropertyBuy"
        element={
          <LayoutWithNavbar>
            <DetailsPropertyBuy />
          </LayoutWithNavbar>
        }
      />
      <Route
        path="/allProducts"
        element={
          <LayoutWithNavbar>
            <AllProducts />
          </LayoutWithNavbar>
        }
      />

      <Route path="/" element={<PrivateRoute />}>
        <Route
          path="/home"
          element={
            <LayoutWithNavbar>
              <HomeRouter />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/mySpace"
          element={
            <LayoutWithNavbar>
              <MySpace />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/homeBuy"
          element={
            <LayoutWithNavbar>
              <HomeBuy />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/homeSeller"
          element={
            <LayoutWithNavbar>
              <HomeSeller />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/registerCreditCard"
          element={
            <LayoutWithNavbar>
              <MySpaceBankRegister />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/DetailsPropertyBuy/:id"
          element={
            <LayoutWithNavbar>
              <DetailsPropertyBuy />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/detailsPropertySeller/:id"
          element={
            <LayoutWithNavbar>
              <DetailsPropertySeller />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/cart"
          element={
            <LayoutWithNavbar>
              <Cart />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/profileSeller"
          element={
            <LayoutWithNavbar>
              <ProfileSeller />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/settings"
          element={
            <LayoutWithNavbar>
              <Settings />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/registerProperty"
          element={
            <LayoutWithNavbar>
              <RegisterProperty />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/updateProperty/:id"
          element={
            <LayoutWithNavbar>
              <UpdateProperty />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/creditCard"
          element={
            <LayoutWithNavbar>
              <CreditCardPage />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/satelite"
          element={
            <LayoutWithNavbar>
              <Satelite />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/mapBiomas"
          element={
            <LayoutWithNavbar>
              <MapBiomas />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/order"
          element={
            <LayoutWithNavbar>
              <Order />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/CreditCardPayment"
          element={
            <LayoutWithNavbar>
              <CreditCardPayment />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/Pix"
          element={
            <LayoutWithNavbar>
              <Pix />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/Ticket"
          element={
            <LayoutWithNavbar>
              <Ticket />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/PaySuccess"
          element={
            <LayoutWithNavbar>
              <PaySuccess />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/PayError"
          element={
            <LayoutWithNavbar>
              <PayError />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/contract/:id"
          element={
            <LayoutWithNavbar>
              <Contract />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/report-requests"
          element={
            <LayoutWithNavbar>
              <EngineerReportRequests />
            </LayoutWithNavbar>
          }
        />
        <Route
          path="/report-upload/:id"
          element={
            <LayoutWithNavbar>
              <PropertyReport />
            </LayoutWithNavbar>
          }
        />
      </Route>
    </Routes>
  );
}
